export const createCompany = (values) => (dispatch, getState, { api }) => {
  return api.post("/authenticate/create", values);
};
